import React, { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';
import { useIsLegacyWikiDocs } from '../wiki/useIsLegacyWikiDocs';

export const ReaderPageBySection = ({ children }: PropsWithChildren<{}>) => {
  const { '*': path = '' } = useParams();
  const isWiki = useIsLegacyWikiDocs();
  return (
    <React.Fragment key={isWiki ? path : undefined}>{children}</React.Fragment>
  );
};
